import { render } from "./PanelCenter.vue?vue&type=template&id=2454845b&scoped=true"
import script from "./PanelCenter.vue?vue&type=script&lang=js"
export * from "./PanelCenter.vue?vue&type=script&lang=js"

import "./PanelCenter.vue?vue&type=style&index=0&id=2454845b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2454845b"]])

export default __exports__